import { FC } from 'react';

export interface ExtremeRiskIconProps {
  fontSize?: number;
}

export const ExtremeRiskIcon: FC<ExtremeRiskIconProps> = ({ fontSize }) => (
  <img
    src="/svg/China_Emblem_PLA.svg"
    alt="PLA Star Emblem"
    role="img"
    style={{
      width: fontSize ?? 24,
      height: fontSize ?? 24,
    }}
  />
);
